import styled from 'styled-components';
import { PropsWithAs, StyledGeneric } from './StyledGeneric';

/* Constants */
export const fontFamilies = {
  bold: "'Avenir Black', 'Arial Black', sans-serif;",
  regular: "'Avenir', 'Arial', sans-serif;"
};

/* Components */
const FontDiv = styled.div`
  font-family: '${fontFamilies.regular};
`;

const BoldFontDiv = styled.div`
  font-family: ${fontFamilies.bold};
`;

export const Font = (props: PropsWithAs) => {
  const { as, ...propsWithoutAs } = props;
  return StyledGeneric(FontDiv, as, propsWithoutAs);
};

export const BoldFont = (props: PropsWithAs) => {
  const { as, ...propsWithoutAs } = props;
  return StyledGeneric(BoldFontDiv, as, propsWithoutAs);
};
